import { Observable } from 'rxjs/Observable';
import { AngularFirestoreCollection, AngularFirestore, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Component, OnInit } from '@angular/core';
import 'rxjs/add/operator/map';

interface Note {
  name: string;
  description?: number;
  img?: string;
}

@Component({
  selector: 'app-knee-on-belly-escaping',
  templateUrl: './knee-on-belly-escaping.component.html',
  styleUrls: ['./knee-on-belly-escaping.component.css']
})
export class KneeOnBellyEscapingComponent implements OnInit {

  notesCollection2: AngularFirestoreCollection<Note>; // collection
  notes2: Observable<Note[]>; // observable

  notesCollection3: AngularFirestoreCollection<Note>; // collection
  notes3: Observable<Note[]>; // observable

  notesCollection4: AngularFirestoreCollection<Note>; // collection
  notes4: Observable<Note[]>; // observable

  notesCollection5: AngularFirestoreCollection<Note>; // collection
  notes5: Observable<Note[]>; // observable

  public show: boolean = false;
  public show2: boolean = false;

  public link1: string = "/closedGuardAttacking";
  public link1txt: string = "Closed Guard Attacking";
  public link2: string = "/closedGuardAttacking";
  public link2txt: string = "Closed Guard Attacking";

  toggleDiv() {
    this.show = false;
    this.show2 = true;
  }

  toggleDiv2() {
    this.show = true;
    this.show2 = false;
  }

  constructor(private afs: AngularFirestore) { }

  ngOnInit() {

    this.notesCollection2 = this.afs.collection('escapingPositions') // reference
    this.notes2 = this.notesCollection2.valueChanges() // observable data

    this.notesCollection3 = this.afs.collection('escapingPositions', ref => {
      return ref.where('name', '==', 'Knee on Belly Escaping')
    }) // reference
    this.notes3 = this.notesCollection3.valueChanges() // observable data

    this.notesCollection4 = this.afs.collection('escapingPositions').doc('kneeOnBellyEscaping')
      .collection('kneeOnBellyEscapingReactions', ref => {
        return ref.where('name', '==', 'Recover Guard')
      }) // reference
    this.notes4 = this.notesCollection4.valueChanges() // observable data

    this.notesCollection5 = this.afs.collection('escapingPositions').doc('kneeOnBellyEscaping')
      .collection('kneeOnBellyEscapingReactions', ref => {
        return ref.where('name', '==', 'Roll Away and Granby')
      }) // reference
    this.notes5 = this.notesCollection5.valueChanges() // observable data
  }

}



// WEBPACK FOOTER //
// ./src/app/knee-on-belly-escaping/knee-on-belly-escaping.component.ts